import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

const WIDTH = 382;
const WIDER_WIDTH = 400;

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(19),
      padding: theme.spacing(1.75, 1.5),
      color: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${COLORS.gray.gray60}`,
      '&$open $iconDropDown': {
        transform: 'rotate(180deg)',
      },
      '&:disabled': {
        backgroundColor: COLORS.gray.gray80,
      },
      '&:focus': {
        borderColor: COLORS.primary.default,
      },
      '&$open': {
        borderColor: COLORS.primary.default,
      },
      '&$error': {
        borderColor: COLORS.error.default,
      },
    },
    listTitle: {
      width: `calc(100% - ${theme.spacing(2)}px)`,
      margin: 'auto',
      padding: theme.spacing(2, 1, 1, 1),
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      color: COLORS.gray.gray40,
      fontWeight: theme.typography.fontWeightSemiBold,
    },
    unclickable: {
      cursor: 'default',
    },
    open: {},
    textWrapper: {
      flex: 1,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      overflow: 'hidden',
    },
    title: {
      flexShrink: 0,
    },
    description: {
      color: COLORS.gray.gray40,
    },
    iconDropDown: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      marginLeft: theme.spacing(2),

      // HINT: we need to overcome specificity of ".MuiButton-iconSizeMedium > *:first-child"
      '&&': {
        fontSize: theme.typography.pxToRem(12),
      },
    },
    menu_paper: {
      width: WIDTH,
      marginTop: theme.spacing(-1),
      border: theme.shape.borderGray70,
      '&$wider': {
        width: WIDER_WIDTH,
      },
    },
    wider: {},
    menu_list: {
      display: 'flex',
      flexFlow: 'column nowrap',
      rowGap: theme.spacing(0.5),
      maxHeight: 460,
      overflowY: 'auto',
    },
    button: {
      minHeight: 40,
      flexShrink: 0,
    },
    newButtonTitle: {
      color: COLORS.primary.default,
    },
    customFormulaTitle: {
      maxWidth: 300,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    customFormulaDescription: {
      width: 300,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    error: {},
    emptyStateTitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(20),
      color: COLORS.neutral.mediumGray,
      padding: theme.spacing(1, 3, 0.5),
    },
    customFormulas: {
      width: '100%',
    },
    customFormulasGroupWrapper: {
      paddingBottom: theme.spacing(1.25),
      marginBottom: theme.spacing(0.75),
      borderBottom: theme.shape.borderGray70,
    },
  }),
  {
    name: 'GenerationModeList',
  }
);
